import React, { Fragment, useCallback, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { getInt } from '../../../../utils/functions';
import Header from './Header';
import HeaderLinks from './HeaderLinks';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import ReportContainer from './ReportContainer';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_REPORTS } from 'constants/rightsCodes';

const ReportItemRoute = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const match = useRouteMatch();
  const [title, setTitle] = useState('');
  const id = match.params.id && getInt(match.params.id);

  const onClickClose = () => {
    historyContext.push(`/reports`);
  };

  const onChangeReportItemTitle = reportItemTitle => {
    setTitle(reportItemTitle);
  };

  const onRedirect = useCallback(
    id => {
      historyContext.push(`/reports/${id}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title || ''} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} title={title || ''} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_REPORTS}>
        <ReportContainer reportId={id} onChangeReportItemTitle={onChangeReportItemTitle} onRedirect={onRedirect} />
      </PermissionCheck>
    </Fragment>
  );
};

ReportItemRoute.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(ReportItemRoute);
